import { render } from "./OptionSelect.vue?vue&type=template&id=b0404548&scoped=true"
import script from "./OptionSelect.vue?vue&type=script&lang=js"
export * from "./OptionSelect.vue?vue&type=script&lang=js"

import "./OptionSelect.vue?vue&type=style&index=0&id=b0404548&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0404548"]])

export default __exports__